import * as actionTypes from "../../Action/actionTypes";

const initialState = {
  Sub_Event_Table: {

    columns: [
      {
        label: 'Name',
        field: 'name',
        sort: 'asc'
      },
      {
        label: 'Start Time',
        field: 'Start_Date',
        sort: 'asc'
      },
      {
        label: 'End Time',
        field: 'End_Date',
        sort: 'asc'
      },
      {
        label: 'Send Invitations',
        field: 'action',
        sort: 'asc'
      }

    ]
  },

};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default reducer;
